export const BREAKPOINT_700PX = '700px';
